import { createContext, useMemo, type ReactNode } from 'react'
import { createServiceStatusStore, type ServiceStatusStore } from './store'

export const ServiceStatusContext = createContext<ServiceStatusStore | null>(null)

export const ServiceStatusProvider = ({ store, children }: { store?: ServiceStatusStore; children: ReactNode }) => {
  const value = useMemo(() => store ?? createServiceStatusStore(), [store])
  return <ServiceStatusContext.Provider value={value}>{children}</ServiceStatusContext.Provider>
}
